var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonajeDudaH(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 274.239,
    height: 297,
    viewBox: "0 0 274.239 297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PersonajeDudaH",
    transform: "translate(3888.944 -106.937)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1",
    transform: "translate(-3888.944 106.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    fill: "none",
    stroke: "#1c1a24",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M-3778.3,246.421",
    "data-name": "Path 33",
    transform: "translate(3916.223 -72.548)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    fill: "#1c1a24",
    d: "M-3742.689,146.092s35.647,1.91,38.511,19.733-10.185,48.058-10.185,48.058l-22.916-43.6Z",
    "data-name": "Path 34",
    transform: "translate(3925.003 -97.284)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    fill: "#ff4527",
    d: "M-3655.84,238.586h-8.174a93.909,93.909,0,0,0,.7-11.219,93.492,93.492,0,0,0-95.745-93.464c-43.252,1.017-79.537,31.912-88.889,72.691a35.911,35.911,0,0,0-5.466-.419,35.527,35.527,0,0,0-35.525,35.527,35.527,35.527,0,0,0,35.525,35.527A35.393,35.393,0,0,0-3838,273.717a93.438,93.438,0,0,0,81.188,47.141h100.969a41.136,41.136,0,0,0,41.136-41.136h0A41.136,41.136,0,0,0-3655.84,238.586Z",
    "data-name": "Path 35",
    transform: "translate(3888.944 -100.295)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    fill: "#1c1a24",
    d: "M-3733.1,203.425c.021,4.6,16.66,4.524,16.641-.071a8.32,8.32,0,0,0-8.355-8.285A8.32,8.32,0,0,0-3733.1,203.425Z",
    "data-name": "Path 36",
    transform: "translate(3927.368 -85.208)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    cx: 27.226,
    cy: 27.226,
    r: 27.226,
    fill: "#e4e3c2",
    "data-name": "Ellipse 9",
    transform: "translate(85.142 152.382)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    fill: "#1c1a24",
    d: "M-3794.1,203.425c.021,4.6,16.661,4.524,16.641-.071a8.32,8.32,0,0,0-8.355-8.285A8.321,8.321,0,0,0-3794.1,203.425Z",
    "data-name": "Path 37",
    transform: "translate(3912.328 -85.208)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(168.355 109.206)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    width: 2.493,
    height: 33.38,
    fill: "#1c1a24",
    "data-name": "Rectangle 19",
    transform: "translate(0 0.828) rotate(-19.397)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(155.956 151.403)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    fill: "#1c1a24",
    d: "M-3762.729,245.127l-1.1-2.235c4.116-2.032,40.455-19.668,49.041-13,1.207.937,2.488,2.792,1.744,6.313l-2.438-.516c.579-2.731-.486-3.556-.834-3.828C-3722.558,227.018-3751.936,239.8-3762.729,245.127Z",
    "data-name": "Path 38",
    transform: "translate(3763.834 -228.395)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(177.041 162.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    fill: "#1c1a24",
    d: "M-3746.4,242.284l-.521-2.438c4.885-1.042,16.463-3.4,18.479-2.721l-.79,2.365C-3730.465,239.21-3738.937,240.692-3746.4,242.284Z",
    "data-name": "Path 39",
    transform: "translate(3746.919 -237.005)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(97.431 85.513)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    fill: "#1c1a24",
    d: "M-3806.425,200.158a4.329,4.329,0,0,1-2.437-.748,4.354,4.354,0,0,1-1.181-6.04c5.719-8.516,22.544-22.839,45.286-16.072a4.362,4.362,0,0,1,2.938,5.426,4.363,4.363,0,0,1-5.426,2.937c-22.187-6.6-35.026,11.8-35.561,12.585A4.377,4.377,0,0,1-3806.425,200.158Z",
    "data-name": "Path 40",
    transform: "translate(3810.783 -175.537)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(178.349 97.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    fill: "#1c1a24",
    d: "M-3722.429,199.862c-11.765,0-21.16-6.849-21.68-7.234a4.362,4.362,0,0,1-.9-6.1,4.358,4.358,0,0,1,6.092-.907c.165.12,13.009,9.347,25.02,3.6a4.358,4.358,0,0,1,5.817,2.053,4.361,4.361,0,0,1-2.053,5.818A28.213,28.213,0,0,1-3722.429,199.862Z",
    "data-name": "Path 41",
    transform: "translate(3745.87 -184.761)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    fill: "#1c1a24",
    d: "M-3853.214,212.895s11.776-.14,12.731,19.593,23.87,13.049,22.278-35.009,126.989-28.962,126.989-28.962,56.333,11.775,42.011-36.283-67.473-11.457-67.473-11.457-9.229-23.87-43.6-8.912-74.792,40.419-74.792,40.419-70.02-2.228-42.967,69.383A42.3,42.3,0,0,1-3853.214,212.895Z",
    "data-name": "Path 42",
    transform: "translate(3890.1 -106.937)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    cx: 27.226,
    cy: 27.226,
    r: 27.226,
    fill: "#e4e3c2",
    "data-name": "Ellipse 10",
    transform: "translate(211.043 152.382)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_3",
    "data-name": "Capa 3",
    transform: "translate(-3747.216 265.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    fill: "#1c1a24",
    d: "M-3663.545,309.367c-1.092-5.243-4.333-10.31-8.974-14.608a28.729,28.729,0,0,0,1.115-11.13c-.695-5.161-3.952-10.061-8.777-12.059,5.655-7.629,12.263-15.852,14.478-20.349,2.688-5.454,3.5-11.886-1.124-15.354a8.225,8.225,0,0,0-6.076-1.415c-4.288.6-7.541,3.378-10.675,6.088-20.059,17.346-29.186,25.17-49.243,42.517,0,0-2.439-29.493-15.808-29.493-13.688,0-3.077,23.976-19.945,52.62-.211.363-.426.723-.637,1.078a43.224,43.224,0,0,0,11.8,57h0a43.237,43.237,0,0,0,51.675-.637l17.684-13.524C-3680.631,344.238-3659.13,330.563-3663.545,309.367Z",
    "data-name": "Path 43",
    transform: "translate(3775.248 -234.361)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonajeDudaH);
export default __webpack_public_path__ + "static/media/PersonajeDudaH.68198a1ebd1cda11eff626229757e1df.svg";
export { ForwardRef as ReactComponent };